export default "__VITE_ASSET__DYWgaTeJ__"